import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "@lib/i18n";

import Typography from "@components/shared/Typography";
import RequestButton from "@components/shared/RequestButton";
import Modal from "@components/shared/Modal";

import { useIsAssistedSalesDisabledPopinVisibleSelector } from "@redux/reducers/errors";
import { setIsAssistedSalesDisabledPopinVisibleAction } from "@redux/actions/errorsActions";

const AssistedSalesDisabledModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isOpen = useIsAssistedSalesDisabledPopinVisibleSelector();

  const modalFirstElement = useRef(null);

  const onClose = () =>
    dispatch(setIsAssistedSalesDisabledPopinVisibleAction(false));

  return (
    <Modal
      ariaLabel={t("assistedSalesDisabledModal.message")}
      disableBackdropClick
      firstElement={modalFirstElement}
      isOpen={isOpen}
      onClose={onClose}
    >
      <div
        className="flex flex-col items-center h-full gap-8 py-4 text-center"
        data-id="assisted-sales-disabled-modal-container"
      >
        <Typography>{t("assistedSalesDisabledModal.message")}</Typography>
        <RequestButton
          data-id="assisted-sales-disabled-modal-continue-btn"
          ref={modalFirstElement}
          triggerRequestCallback={onClose}
        >
          {t("general.continue")}
        </RequestButton>
      </div>
    </Modal>
  );
};

export default AssistedSalesDisabledModal;
